<!-- Button that cycles the theme: system -> light -> dark -->
<template>
  <v-tooltip bottom open-delay="300">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        id="theme-switcher-btn"
        icon
        v-bind="attrs"
        v-on="on"
        :aria-label="tooltipTitle"
        @click="nextMode"
      >
        <v-icon>{{ icons[themeState.mode] }}</v-icon>
      </v-btn>
    </template>
    <div class="tw-text-center">
      <div>{{ tooltipTitle }}</div>
      <div class="tw-text-xs tw-opacity-80">{{ $t("theme.clickToSwitch") }}</div>
    </div>
  </v-tooltip>
</template>

<script>
import { themeModes, themeState, setThemeMode } from "@/theme"

export default {
  name: "ThemeSwitcher",

  data: () => ({
    themeState,
    icons: {
      system: "mdi-circle-half-full",
      light: "mdi-white-balance-sunny",
      dark: "mdi-weather-night",
    },
  }),

  computed: {
    tooltipTitle() {
      if (themeState.mode !== "system") return this.$t(`theme.${themeState.mode}`)
      return this.$t("theme.systemCurrent", {
        current: this.$t(themeState.dark ? "theme.nowDark" : "theme.nowLight"),
      })
    },
  },

  methods: {
    nextMode() {
      const i = themeModes.indexOf(themeState.mode)
      setThemeMode(themeModes[(i + 1) % themeModes.length])
    },
  },
}
</script>
